export const RACE_STATUS_OPTIONS = [
  { label: 'Upcoming', value: 'UPCOMING' },
  { label: 'Active', value: 'ACTIVE' },
  { label: 'Complete', value: 'COMPLETE' },
];

export type RaceDetailField = 'is_incumbent' | 'is_self_funded' | 'is_pay_to_play_issue';

export const RACE_DETAIL_CHECKS: { field: RaceDetailField; label: string }[] = [
  { field: 'is_incumbent', label: 'Incumbent' },
  { field: 'is_self_funded', label: 'Self-funded' },
  { field: 'is_pay_to_play_issue', label: 'Pay to play issue' },
];
